module.exports = __webpack_public_path__ + "img/carrousel-intervensionista-2.e3cbe41e.png";